var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3899 7.41005C23.9367 7.95678 23.9367 8.84322 23.3899 9.38995L12.1899 20.5899C11.6432 21.1367 10.7568 21.1367 10.2101 20.5899L4.61005 14.9899C4.06332 14.4432 4.06332 13.5568 4.61005 13.0101C5.15678 12.4633 6.04322 12.4633 6.58995 13.0101L11.2 17.6201L21.4101 7.41005C21.9568 6.86332 22.8432 6.86332 23.3899 7.41005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckImg);
export default __webpack_public_path__ + "static/media/check-img.337f01217009ef0fb9e0e7f5e844f02c.svg";
export { ForwardRef as ReactComponent };